import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// Entrance reveal wrapper — respects reduced motion
export const Reveal = ({ children, delay = 0, y = 16, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const Stagger = ({ children, className = "", stagger = 0.09 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: reduce ? 0 : stagger } },
      }}
    >
      {children}
    </motion.div>
  );
};

export const StaggerItem = ({ children, className = "", y = 16 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      variants={{
        hidden: reduce ? { opacity: 1 } : { opacity: 0, y },
        show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
      }}
    >
      {children}
    </motion.div>
  );
};

// Eyebrow / overline label
export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-block text-xs font-semibold tracking-[0.22em] uppercase text-slateink ${className}`}
  >
    {children}
  </span>
);

// Small badge used inside dashboards
export const StatusBadge = ({ children, tone = "success", dot = true }) => {
  const tones = {
    success: "bg-[#ECFDF5] text-[#059669] border-[#A7F3D0]",
    warning: "bg-[#FFFBEB] text-[#D97706] border-[#FDE68A]",
    info: "bg-demax-soft text-demax border-[#CFE0FF]",
    neutral: "bg-slate-50 text-slateink border-slate-200",
  };
  const dotTone = {
    success: "bg-[#10B981]",
    warning: "bg-[#F59E0B]",
    info: "bg-demax",
    neutral: "bg-slate-400",
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-[11px] font-semibold ${tones[tone]}`}
    >
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${dotTone[tone]}`} />}
      {children}
    </span>
  );
};
